export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS"